export default "__VITE_ASSET__713a5ff3__"